var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Product" }, [
    _c(
      "div",
      { staticClass: "Product__hover-container" },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.totalVariant == 1 || _vm.isClothes || _vm.isOnDemand,
                expression: "totalVariant == 1 || isClothes || isOnDemand"
              }
            ],
            staticClass: "Product__image-container",
            on: {
              click: function($event) {
                return _vm.openModal()
              }
            }
          },
          [
            _vm.totalVariant > 1 && !_vm.isClothes
              ? _c("img", {
                  staticClass: "Product__image",
                  attrs: {
                    src: _vm._f("getProductVariantImage")(
                      _vm.product,
                      _vm.selectedVariant
                    )
                  }
                })
              : _c("img", {
                  staticClass: "Product__image",
                  attrs: { src: _vm._f("getProductImage")(_vm.product) }
                })
          ]
        ),
        _vm._v(" "),
        _vm.totalVariant > 1 && !_vm.isClothes && !_vm.isOnDemand
          ? _c(
              "VueSlickCarousel",
              {
                staticClass: "Product__image-container",
                staticStyle: { "margin-bottom": "0px" },
                attrs: {
                  lazyLoad: "progressive",
                  adaptiveHeight: false,
                  draggable: false,
                  dots: true,
                  dotsClass: "Product__carousel-dot-container",
                  infinite: false,
                  arrows: false,
                  slidesToShow: 1,
                  slidesToScroll: 1
                },
                on: { afterChange: _vm.afterChangeCarousel },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "customPaging",
                      fn: function(page) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "Product__carousel-dot",
                              class: [
                                page == _vm.currentCarouselIndex
                                  ? "Product__carousel-dot--selected"
                                  : "",
                                _vm.product.variants[page].available == false
                                  ? "Product__carousel-dot--disabled"
                                  : ""
                              ],
                              style: {
                                "background-color": _vm.colorVariants[page]
                                  ? _vm.colorVariants[page]
                                  : "#fff"
                              }
                            },
                            [
                              !_vm.colorVariants[page]
                                ? _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.product.variants[
                                            page
                                          ].title.charAt(0)
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3573822282
                )
              },
              _vm._l(_vm.product.variants, function(variant) {
                return _c(
                  "div",
                  {
                    key: variant.id,
                    staticClass: "Product__option-container",
                    class: [
                      variant.available == false
                        ? "Product__option-container--disabled"
                        : ""
                    ],
                    on: {
                      click: function($event) {
                        return _vm.openModal()
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "Product__image",
                      attrs: {
                        src: _vm._f("getProductVariantImage")(
                          _vm.product,
                          variant.id
                        )
                      }
                    })
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "Product__button",
            class: [
              _vm.totalVariant > 1 && !_vm.isClothes
                ? "Product__button-slider"
                : ""
            ],
            on: {
              click: function($event) {
                return _vm.openModal()
              }
            }
          },
          [_vm._v("view")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", { staticClass: "Product__title" }, [
      _vm._v(_vm._s(_vm.product.title + _vm.selectedVariantTitle))
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "Product__price" }, [
      _vm._v(_vm._s(_vm._f("moneyFormat")(_vm.product)))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }